module.exports = __webpack_public_path__ + "/login_ui/img/rs-3e5164565fa781bb0573649e85f8db12.svg";